export const defaultModel = [
    {
        label: "swan 600",
        value: "Swan600",
    },
    {
        label: "swan 600P",
        value: "Swan600P",
    },
    {
        label: "swan 700",
        value: "Swan700",
    },
    {
        label: "swan 700P",
        value: "Swan700P",
    },
];

export const productOption = [
    {
        label: "固定底座",
        value: "fixedbase",
        number: "101"
    },
    {
        label: "运动底座",
        value: "sportsBase",
        number: "102",
    },
    {
        label: "手柄",
        value: "handle",
        number: "103"
    },
    {
        label: "三大件",
        value: "threeMajorItems",
        number: "104"
    },
    {
        label: "束腰",
        value: "girdling",
        number: "201"
    },
    {
        label: "波形调试",
        value: "referenceArm",
        number: "202"
    },
    {
        label: "绕光纤参考臂",
        value: "fiberOpticReferenceArm",
        number: "203"
    },
    {
        label: "探测器",
        value: "detector",
        number: "018"
    },
    {
        label: "完整参考臂",
        value: "completeReferenceArm",
        number: "301"
    },
    {
        label: "定标",
        value: "calibrate",
        number: "302"
    },
    {
        label: "总装调试",
        value: "assembleDebug",
        number: "401"
    },
]
